import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { addTransition } from "../../redux/actions/actions";
import { toggleIframe } from "../../redux/actions/model";
import Icon from "../icon/index";
import "./style.scss";
import classNames from "classnames";
import { Text } from "@sitecore-jss/sitecore-jss-react";
import { openModal } from "../../utils";
import { Link } from "react-router-dom";
import { getPageName } from "../../utils/urlHelper";
import { normalizeHref } from "../../utils/siteUtils";
import { WaveIcon } from "../../elements";

class PrimaryButton extends PureComponent {
  // shouldComponentUpdate(nextProps, nextState) {
  //   return false;
  // }
  handleClick(event) {
    const { isPageTransition, pageTransitionTitle, pageTransitionCurtainColor, pageTransitionCurtainDirection, isShowModal, nestedGrid, link, toggleIframe, addTransition, callback, isDisabled } = this.props;
    if ((isDisabled && isDisabled.value) || isDisabled === true) {
      return false;
    }
    if (isPageTransition && isPageTransition.value) {
      event.preventDefault();
      addTransition(
        "page-curtain",
        link && link.value.href,
        pageTransitionTitle && pageTransitionTitle.value,
        (pageTransitionCurtainDirection && pageTransitionCurtainDirection.fields && pageTransitionCurtainDirection.fields.phrase.value === "right-to-left") || false,
        link && link.value.linktype,
        pageTransitionCurtainColor && pageTransitionCurtainColor.fields && pageTransitionCurtainColor.fields.phrase.value
      );
      return;
    }
    if (isShowModal && isShowModal.value) {
      toggleIframe("", nestedGrid.value);
      openModal(link.value.id);
      return;
    }

    if (Object.prototype.toString.call(callback) === "[object Function]") {
      callback(event);
    }
  }
  render() {
    const { colorScheme, width, isDisabled, link, hash, iconName, iconDef, size, buttonText, id, callback, file, btnText, wave } = this.props;
    const hasIcon = !!iconName?.value?.src || iconDef;
    const hasWave = wave;
    const iconModal = {
      icon: iconName ? iconName.value : "",
      name: iconDef,
      type: "primary-button"
    },
      widthClass = width ? width : "auto";

    let buttonTextValue = buttonText?.value ?? link?.value?.text ?? buttonText;
    buttonTextValue = btnText && btnText?.value ? btnText?.value : buttonTextValue

    const classes = classNames("primary-button ", colorScheme?.fields?.phrase?.value || "primary", `size-${size?.fields?.phrase?.value ?? size ?? "normal"}`, widthClass, {
      disabled: (isDisabled && isDisabled.value) || isDisabled === true
    });
    let { linktype, href, target } = link?.value || {};
    if (href) {
      if (href.startsWith("mailto:tel:")) {
        href = href.replace("mailto:tel:", "tel:");
      }
      if (hash && href.indexOf("#") < 0) {
        href += `#${getPageName(href)}-${hash.id}`;
      }
    }

    const innerButtonContent = () => {
      return (
        <span className={classNames("primary-button__content", { "no-icon": !hasIcon && !hasWave })} tabIndex="-1">
          {buttonTextValue != null && <Text tag="span" className="buttonText" field={{ value: buttonTextValue }} />}
          {hasIcon && (
            <div className="icon-container">
              <Icon {...iconModal} />
            </div>
          )}

          {hasWave && (
            <div className="icon-container">
              <WaveIcon />
            </div>
          )}

        </span>

      );
    };
    if (linktype === "internal") {
      if (/^https?:/gi.test(href)) {
        return (
          <Link className={classes} to={link?.value?.href} target={link?.value?.target} type="button" tabIndex="0" id={id}>
            {innerButtonContent()}
          </Link>
        );
      } else if (callback) {
        return (
          <Link to={normalizeHref(href) || "#"} target={target} className={classes} tabIndex="0" id={id} onClick={callback}>
            {innerButtonContent()}
          </Link>
        );
      } else {
        return (
          <Link to={normalizeHref(href)} target={target} className={classes} tabIndex="0" id={id}>
            {innerButtonContent()}
          </Link>
        );
      }
    }

    if (linktype === "external") {
      if (/^https?:/gi.test(href)) {
        return (
          <a className={classes} href={link?.value?.href} target={link?.value?.target} type="button" tabIndex="0" id={id}>
            {innerButtonContent()}
          </a>
        );
      }
    }

    if (callback) {
      return (
        <button className={classes} onClick={this.handleClick.bind(this)} type="button" tabIndex="0" id={id}>
          {innerButtonContent()}
        </button>
      );
    }

    if (href === "javascript:;return false;" || /^https?:\/\/$/.test(href)) {
      href = null;
    }
    if (file?.value?.src) {
      return (
        <Link download className={classes} to={file?.value?.src ? file.value.src : link?.value?.href} target="_blank" type="button" tabIndex="0" id={id}>
          {innerButtonContent()}
        </Link>
      );
    }
    if (link?.value?.href) {
      return (
        <Link className={classes} to={file?.value?.src ? file.value.src : normalizeHref(link?.value?.href)} target={link?.value?.target} type="button" tabIndex="0" id={id}>
          {innerButtonContent()}
        </Link>
      )
    } else {
      return (
        <span className={classes} href={file?.value?.src ? file.value.src : normalizeHref(link?.value?.href)} target={link?.value?.target} type="button" tabIndex="0" id={id}>
          {innerButtonContent()}
        </span>
      );
    }
  }
}

const mapDispatchToProps = {
  addTransition: addTransition,
  toggleIframe: toggleIframe
};

export default connect(null, mapDispatchToProps)(PrimaryButton);
